export enum ACTIVITY_ACTION_TYPES {
  FETCH_ALL_DATA = "activity/FETCH_ALL_DATA",
  SET_IS_LOADING = "activity/SET_IS_LOADING",
}
